import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { Link } from 'react-router';

import Logo from '../../components/Logo';
import ThemeToggle from '../../components/ThemeToggle';

const messages = defineMessages({
  IMPRINT: {
    id: 'ImprintPage.IMPRINT',
    defaultMessage: 'Impressum',
  },
  BACK_TO_STARTPAGE: {
    id: 'ImprintPage.BACK_TO_STARTPAGE',
    defaultMessage: 'Zurück zur Startseite',
  },
  INFORMATION: {
    id: 'ImprintPage.INFORMATION',
    defaultMessage: 'Angaben gemäß § 5 TMG',
  },
  MANAGER: {
    id: 'ImprintPage.MANAGER',
    defaultMessage: 'Geschäftsführer',
  },
  CONTACT: {
    id: 'ImprintPage.CONTACT',
    defaultMessage: 'Kontakt',
  },
  PHONE: {
    id: 'ImprintPage.PHONE',
    defaultMessage: 'Telefon',
  },
  E_MAIL: {
    id: 'ImprintPage.E_MAIL',
    defaultMessage: 'E-Mail',
  },
  REGISTRATION: {
    id: 'ImprintPage.REGISTRATION',
    defaultMessage: 'Registrierung',
  },
  LISTING: {
    id: 'ImprintPage.LISTING',
    defaultMessage: 'Eintragung im Handelsregister',
  },
  CHANCERY: {
    id: 'ImprintPage.CHANCERY',
    defaultMessage: 'Registergericht',
  },
  REGISTRATION_NUMBER: {
    id: 'ImprintPage.REGISTRATION_NUMBER',
    defaultMessage: 'Registernummer',
  },
  TURNOVER_TAX: {
    id: 'ImprintPage.TURNOVER_TAX',
    defaultMessage: 'Umsatzsteuer-ID',
  },
  VALUE_ADDED_TAX_ACT: {
    id: 'ImprintPage.VALUE_ADDED_TAX_ACT',
    defaultMessage: 'Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz',
  },
});

class ImprintPage extends React.Component {
    render() {
      const { intl: { formatMessage } } = this.props;

        return (
          <div className="anonymous-container" style={{ minHeight: '100vh', width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 20px', background: 'var(--bg-color)' }}>
            <div className="anonymous-card-wrapper" style={{ width: '100%', maxWidth: '800px' }}>
              <div className="anonymous-card" style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '32px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                <div className="anonymous-header" style={{ position: 'relative', padding: '32px 0', borderBottom: '1px solid var(--panel-border)', backgroundColor: 'var(--panel-bg)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Logo large />
                  <div className="anonymous-theme-toggle">
                    <ThemeToggle />
                  </div>
                </div>
              
              <div style={{ padding: '48px', color: 'var(--text-color)', lineHeight: '1.6' }}>
                <h1 style={{ marginTop: 0, marginBottom: '32px', fontSize: '28px', fontWeight: 'bold' }}>
                  {formatMessage(messages.IMPRINT)}
                </h1>
                
                <div style={{ fontSize: '15px' }}>
                  <p>
                    <strong style={{ color: 'var(--primary-color, #3b82f6)' }}>{formatMessage(messages.INFORMATION)}:</strong><br />
                    Solutiness GmbH<br />
                    Edisonallee 39<br />
                    D-89231 Neu-Ulm
                  </p>
                  
                  <p>
                    <strong style={{ color: 'var(--primary-color, #3b82f6)' }}>{formatMessage(messages.CONTACT)}:</strong><br />
                    Telefon: +49 731 85 07 42 20<br />
                    E-Mail: <a href="mailto:info@tele-look.com" style={{ color: '#3b82f6', textDecoration: 'none' }}>info@tele-look.com</a>
                  </p>
                  
                  <p>
                    <strong style={{ color: 'var(--primary-color, #3b82f6)' }}>Vertretungsberechtigte Geschäftsführerin:</strong><br />
                    Regina Keller-Sylla
                  </p>
                  
                  <p>
                    <strong style={{ color: 'var(--primary-color, #3b82f6)' }}>Registerangaben:</strong><br />
                    Handelsregister: HRB 21624<br />
                    Registergericht: Amtsgericht Memmingen
                  </p>
                  
                  <p>
                    <strong style={{ color: 'var(--primary-color, #3b82f6)' }}>{formatMessage(messages.TURNOVER_TAX)}:</strong><br />
                    DE 305720076
                  </p>
                  
                  <p>
                    <strong style={{ color: 'var(--primary-color, #3b82f6)' }}>Redaktionell verantwortlich gemäß § 55 RStV:</strong><br />
                    Regina Keller-Sylla<br />
                    Edisonallee 39, D-89231 Neu-Ulm
                  </p>

                  <h2 style={{ marginTop: '32px', marginBottom: '16px', fontSize: '20px', fontWeight: 'bold', color: 'var(--primary-color, #3b82f6)' }}>Haftungsausschluss</h2>
                  
                  <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '16px', marginBottom: '8px' }}>Haftung für Inhalte</h3>
                  <p>
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
                  </p>

                  <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '16px', marginBottom: '8px' }}>Haftung für Links</h3>
                  <p>
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft – rechtswidrige Inhalte waren dabei nicht erkennbar.
                  </p>

                  <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '16px', marginBottom: '8px' }}>Bildernachweis</h3>
                  <p>
                    Die verwendeten Bilder und Grafiken stammen aus: Shutterstock und CanvaPro.
                  </p>

                  <h2 style={{ marginTop: '32px', marginBottom: '16px', fontSize: '20px', fontWeight: 'bold', color: 'var(--primary-color, #3b82f6)' }}>Online-Streitbeilegung</h2>
                  <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit, die Sie als Verbraucher für außergerichtliche Streitbeilegung nutzen können.
                  </p>
                  <p>
                    🔗 <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', textDecoration: 'none' }}>ec.europa.eu/consumers/odr &rarr;</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
            
            <div className="text-center" style={{ marginTop: '32px' }}>
              <Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '8px' }} onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}>
                <i className="fa fa-arrow-left" /> {formatMessage(messages.BACK_TO_STARTPAGE)}
              </Link>
            </div>
          </div>
        );
    }
}

export default injectIntl(ImprintPage);
